class EmployeeEmployerRegisterService {

    register(employer, setIsRegistered,setEmployeeId) {
        fetch("/employeeEmployer/add", {
            method: 'POST',
            headers: {
                'Content-Type' : 'application/json',
                'Accept' : 'application/json'
            },
            body: JSON.stringify(employer)
        }).then(res => res.json()).then(data => {
            setEmployeeId(data['employeeDetailsId']);
            setIsRegistered(data);
        });
    }
}

export default EmployeeEmployerRegisterService;